import script from "./rules.vue?vue&type=script&setup=true&lang=js"
export * from "./rules.vue?vue&type=script&setup=true&lang=js"

import "./rules.vue?vue&type=style&index=0&id=3959d150&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3959d150"]])

export default __exports__